"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModerationQueueStatusEnum = exports.ModerationQueueTypeEnum = void 0;
var ModerationQueueTypeEnum;
(function (ModerationQueueTypeEnum) {
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["teacher_profile"] = 1] = "teacher_profile";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["billing_profile"] = 2] = "billing_profile";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["library_content"] = 3] = "library_content";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["public_meeting"] = 4] = "public_meeting";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["user_service"] = 5] = "user_service";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["collection"] = 6] = "collection";
  ModerationQueueTypeEnum[ModerationQueueTypeEnum["school"] = 7] = "school";
})(ModerationQueueTypeEnum = exports.ModerationQueueTypeEnum || (exports.ModerationQueueTypeEnum = {}));
var ModerationQueueStatusEnum;
(function (ModerationQueueStatusEnum) {
  ModerationQueueStatusEnum[ModerationQueueStatusEnum["pending"] = 1] = "pending";
  ModerationQueueStatusEnum[ModerationQueueStatusEnum["processing"] = 2] = "processing";
  ModerationQueueStatusEnum[ModerationQueueStatusEnum["approved"] = 3] = "approved";
  ModerationQueueStatusEnum[ModerationQueueStatusEnum["declined"] = 4] = "declined";
})(ModerationQueueStatusEnum = exports.ModerationQueueStatusEnum || (exports.ModerationQueueStatusEnum = {}));
/** Очередь модерации */
var ModerationQueue = /** @class */function () {
  function ModerationQueue() {}
  return ModerationQueue;
}();
exports.default = ModerationQueue;
